import { useState, useContext } from 'react'
import { PreviewSize } from './PreviewSize'
import { Row, Card } from 'react-bootstrap';
import { CardConfig, SizeViewConteiner, TitleCard, sizeWidth } from '../../Panel/Component';
import ReactTooltip from 'react-tooltip';
import { PanelContext } from '../../Panel/Context/Panel';
import { Opciones } from '../Utils';
import { MenuTemplate, MenuZise } from '../../Panel/Utiles';
import { Pages } from '../Page';
import { PageContext } from '../PageContext';
export function Ver() {
    const { panels } = useContext(PanelContext);
    const { page } = useContext(PageContext);
    const [size, setSize] = useState<sizeWidth>('1080px')
    return <>
        <Card style={{ backgroundColor: '#ccc', padding: '7px 7px 7px 7px' }}>
            <Row style={{ margin: '0 0 0 0', padding: '0 0 0 0' }}>
                <MenuTemplate />
                <CardConfig width='calc(100% - 370px - .5rem)'>
                    <Pages />
                    <TitleCard>PAGINAS</TitleCard>
                </CardConfig>
                <MenuZise setSize={setSize} size={size} />
            </Row>
        </Card>
        <ReactTooltip key='tooltip' />
        <SizeViewConteiner size={size} h1='calc(100vh - 210px)' h2='calc(100vh - 210px)'>
            {panels.filter(({ pagina, estado }) => page === pagina && (estado === 0 || estado === 1))
                .sort((a, b) => a.indice - b.indice)
                .map((p, i) => <div key={p.type + p.id + i} id={`panel${p.id}${i}`} className='w-100 m-0 p-0'>
                    <Opciones panel={p} />
                    <PreviewSize panel={p} size={size} />
                </div>)}
        </SizeViewConteiner>
    </>
}